let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let accessibility = require('../utilities/accessibility');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

// import Jump
import Jump from 'jump.js'

class GlossaryIndex {

  constructor(context) {
    this.$nav = $('.js-main-nav-wrapper');
    this.$indexWrapper = $('.glossary-index__wrapper');
    this.$backToTop = $('.glossary-section__back');
    this.$glossaryBody = $(".glossary-body");
    this.$stickyIndex;
    this.$stickyIndexNav;
    this.$stickyIndexList;
    this.$indexToggleMobile;
    this.$indexLink;

    /*
      On the labs glossary (which is /research), we use AJAX to reload the glossaries.
    */
    if (context.selector === "#labs-glossary") {
      this.reset();
    }
    else if (this.$indexWrapper.length === 1) {
      this.init();
    }
  }

  reset() {
    $(".glossary-index__wrapper--collapsed").remove();

    this.$nav = $('.js-main-nav-wrapper');
    this.$indexWrapper = $('.glossary-index__wrapper');
    this.$backToTop = $('.glossary-section__back');
    this.$stickyIndex;
    this.$stickyIndexNav;
    this.$stickyIndexList;
    this.$indexToggleMobile;
    this.$indexLink;

    this.init();
  }

  init() {
    this.setupStickyIndex();

    $(window).resize(() => this.resizeIndex()).trigger('resize');
    $(window).off('scroll.glossary').on('scroll.glossary', () => this.checkScroll());

    if (this.$indexWrapper.hasClass('academy')) {
      return;
    }

    // create Jump instance.
    this.jump = new Jump();
    this.$indexLink = $('.glossary-index__letters a');
    this.$indexLink.off('click.indexJump').on('click.indexJump', (e) => this.jumpToSection(e));
    this.$backToTop.off('click.backToTop').on('click.backToTop', (e) => this.backToTop(e));
  }

  jumpToSection(e) {
    let $target = $(e.currentTarget);
    let letter = $target.attr('href').replace(/^#/, '');
    let $elem = $('.glossary-section--' + letter);
    let $backBtn = $elem.find('.glossary-section__back');

    let offset = this.getOffset($elem) - this.$stickyIndex.height();

    this.jump.jump(offset, {
      duration: 250,
      callback: () => {
        $backBtn.focus();
      }
    });

    return false;
  }

  backToTop(e) {
    let $target = $(e.currentTarget);
    let letter = $target.data('letter');
    let offset = this.getOffset(this.$indexWrapper);
    let $letterLink = this.$indexWrapper.find('.glossary-index__letters a[href="#' + letter + '"]');

    this.jump.jump(offset, {
      duration: 250,
      callback: () => {
        $letterLink.focus();
      }
    });

    return false;
  }

  getOffset($elem) {
    let offset;
    let currOffset = $(document).scrollTop();
    let targetOffset = $elem.offset().top;

    offset = targetOffset - currOffset;

    return offset;
  }

  checkScroll() {
    if (!this.$stickyIndex)
      return false;
    if (!this.$indexWrapper.offset())
      return false;
    if (!this.$glossaryBody.offset())
      return false;

    let currPos = $(document).scrollTop();
    let target = this.$indexWrapper.offset().top + this.$indexWrapper.outerHeight();
    let glossaryBodyBottom = this.$glossaryBody.offset().top + this.$glossaryBody.outerHeight() - this.$stickyIndex.outerHeight();

    if (currPos > target && currPos < glossaryBodyBottom && !this.$stickyIndex.hasClass('visible')) {
      this.$stickyIndex.addClass('visible');
    }
    else if ((currPos < target || currPos >= glossaryBodyBottom) && this.$stickyIndex.hasClass('visible')) {
      this.$stickyIndex.removeClass('visible');
    }
  }

  resizeIndex() {
    if (!this.$stickyIndex)
      return false;

    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
      if (this.$stickyIndex.length > 0) {
        this.$stickyIndex.attr('style', '');
      }
    }
    else if (this.$stickyIndex.hasClass('index-open')) {
      let height = this.getIndexHeight();
      this.$stickyIndex.css('height', height);
    }
  }

  setupStickyIndex() {
    this.$stickyIndex = this.$indexWrapper.clone();
    this.$nav.append(this.$stickyIndex.addClass('glossary-index__wrapper--collapsed'));
    this.$indexToggleMobile = this.$stickyIndex.find('.js-glossary-toggle-mobile');
    this.$stickyIndexNav = this.$stickyIndex.find('.glossary-index__nav');
    this.$stickyIndexList = this.$stickyIndex.find('.glossary-index');

    // On the research glossary there are filters that don't belong in the stickyIndex.
    this.$filters = this.$stickyIndex.find('.glossary-index__filter');
    if (this.$filters.length > 0) {
      this.$filters.remove();
    }

    // Bind click to toggle -- which is only available in the collapsed state.
    this.$indexToggleMobile.on('click', (e) => this.handleToggleClick(e));

    // Add aria-hidden true to our sticky nav. B/c it's redundant.
    this.$stickyIndex.attr('aria-hidden', 'true');
    // Remove anchor, we do not want that.
    this.$stickyIndex.find('.glossary-index__anchor').remove();

    // Make sure links in new fixed nav are not tabbable.
    accessibility.toggleTabbing(this.$stickyIndex, false, false);

    // Run checkScroll() so load isn't so jarring if you're down the page.
    this.checkScroll();
  }

  handleToggleClick(e) {
    let $target = $(e.target);
    let $wrapper = $target.parents('.glossary-index__wrapper');

    this.revealMobileIndex();

  }

  revealMobileIndex() {
    this.$stickyIndex.toggleClass('index-open');

    let height = this.getIndexHeight();

    window.TweenLite.to(this.$stickyIndex, .25, {height: height});
  }

  getIndexHeight() {
    let navHeight = this.$stickyIndexNav.outerHeight();
    let bodyHeight = this.$stickyIndexList.outerHeight();
    let height;

    if (this.$stickyIndex.hasClass('index-open')) {
      height = navHeight + bodyHeight;
    }
    else {
      height = navHeight;
    }

    return height;
  }
}

module.exports = {
  attach: function(context, settings) {
    let glossaryIndex = new GlossaryIndex(context);
  }
}
